export default "__VITE_ASSET__BdRbppuf__"